<template>
  <b-container fluid class="application-queue-page">
    <b-form @submit="onSubmit" @reset="onReset">
      <b-card class="application-filter-card mb-3" no-body>
        <div class="application-filter-header d-flex align-items-center justify-content-between">
          <span><i class="fas fa-filter mr-2"></i>Application Search</span>
          <b-button variant="link" size="sm" class="advanced-search-link" v-b-modal.mdlAdvSearch>
            Advanced Search <i class="fa fa-sliders-h ml-1"></i>
          </b-button>
        </div>
        <b-card-body class="py-3">
          <b-row>
            <b-col lg="3" md="6">
              <b-form-group id="grp1" label="Scheme" label-size="sm" label-for="ipLoanType" class="queue-filter-group">
            <b-select
              id="ipLoanType"
              class="form-control queue-filter-input"
              value-field="LoanType"
              size="sm"
              text-field="SchemeName"
              :options="schemes"
              v-model="form.LoanType"
            ></b-select>
              </b-form-group>
            </b-col>
            <b-col lg="3" md="6">
              <b-form-group id="grp2" label="District" label-size="sm" label-for="ipDistrict" class="queue-filter-group">
            <b-select
              id="ipDistrict"
              :options="districts"
              value-field="DistID"
              text-field="DistName"
              required
              size="sm"
              :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
              v-model="form.DistrictID"
              class="form-control queue-filter-input"
            ></b-select>
              </b-form-group>
            </b-col>
            <b-col lg="3" md="6">
              <b-form-group id="grp3" label="Status" label-size="sm" label-for="ipAPSts" class="queue-filter-group">
                <b-select
                  id="ipAPSts"
                  class="form-control queue-filter-input"
                  :options="approvalStatusOptions"
                  value-field="Id"
                  text-field="ApplicationStatus"
                  required
                  size="sm"
                  v-model="form.ApplicationStatusID"
                  @change="onStatusFilterChange"
                ></b-select>
              </b-form-group>
            </b-col>
            <b-col lg="3" md="6">
              <b-form-group id="grp4" label="Application No." label-size="sm" label-for="ipAppNum" class="queue-filter-group">
                <b-input-group size="sm">
                  <b-form-input type="text" id="ipAppNum" v-model="form.ApplicationNo" class="queue-filter-input" placeholder="Search application number" />
                  <b-input-group-append>
                    <b-button type="submit" variant="primary" class="queue-search-button" :disabled="isLoading" title="Search applications">
                <span v-if="isLoading">
                      <b-spinner small></b-spinner>
                </span>
                      <i v-else class="fas fa-search"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-modal id="mdlAdvSearch" ref="mdlAdvSearch" size="lg" title="Advance Search" hide-footer>
        <b-form @submit="onSubmit" @reset="onReset">
          <div class="form-row">
            <b-col md="6" class="mt-3">
              <b-form-group
                id="grp11"
                label-cols="2"
                label="Scheme"
                label-size="sm"
                label-for="ipLoanType"
              >
                <b-select
                  id="ipLoanType"
                  class="form-control"
                  value-field="LoanType"
                  size="sm"
                  text-field="SchemeName"
                  :options="schemes"
                  v-model="form.LoanType"
                ></b-select>
              </b-form-group>
            </b-col>
            <b-col class="mt-3" md="6">
              <b-form-group
                id="grp2"
                label-cols="3"
                label="District"
                label-size="sm"
                label-for="ipDistrict"
              >
                <b-select
                  id="ipDistrict"
                  :options="districts"
                  value-field="DistID"
                  text-field="DistName"
                  required
                  size="sm"
                  :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
                  v-model="form.DistrictID"
                  class="form-control"
                ></b-select>
              </b-form-group>
            </b-col>
          </div>
          <b-row>
            <b-col class="mt-3" md="6">
              <b-form-group
                id="grp13"
                label-cols="2"
                label="Status"
                label-size="sm"
                label-for="ipAPSts"
              >
                <b-select
                  id="ipAPSts"
                  class="form-control"
                  :options="approvalStatusOptions"
                  value-field="Id"
                  text-field="ApplicationStatus"
                  required
                  size="sm"
                  v-model="form.ApplicationStatusID"
                  @change="onStatusFilterChange"
                ></b-select>
              </b-form-group>
            </b-col>
            <b-col class="mt-3" md="6">
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="mt-3">
              <b-form-group
                id="grp14"
                label-cols="4"
                label="Application No"
                label-size="sm"
                label-for="ipAppNum"
              >
                <b-form-input type="text" size="sm" id="ipAppNum" v-model="form.ApplicationNo" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-3" md="8">
              <b-form-group
                id="grp13"
                label-cols="3"
                label="Application Date"
                label-size="sm"
                label-for="ipAPDt"
              >
                <date-picker
                  v-model="appDate"
                  format="DD-MM-YYYY"
                  id="ipAPDt"
                  lang="en"
                  range
                  size="small"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col md="4" class="mt-3">
              <b-form-group
                id="grp14"
                label-cols="4"
                label="Mobile No"
                label-size="sm"
                label-for="ipMobNum"
              >
                <b-form-input type="text" size="sm" id="ipMobNum" v-model="form.MobileNo" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-3">
              <b-button type="submit" size="sm" variant="success" class="float-right mx-2" :disabled="isLoading">
                <span v-if="isLoading">
                  <b-spinner small class="mr-1"></b-spinner>
                  Loading...
                </span>
                <span v-else>Search</span>
              </b-button>
              <b-button type="reset" size="sm" variant="secondary" style="float:right" :disabled="isLoading">Reset</b-button>
            </b-col>
          </b-row>
          <!-- <div class="form-row" v-if="1==2">
            <div class="form-group col-md-4">
              <label for="inputCity">Application No</label>
              <input type="text" class="form-control" id="inputCity" v-model="form.ApplicationNo">
            </div>
            <div class="form-group col-md-4">
              <label for="ipMobile">Mobile No</label>
              <input type="text" class="form-control" id="ipMobile" v-model="form.MobileNo">
            </div>
            <div class="form-group col-md-2" style="valign:bottom">
              <b-button type="submit" size="sm" variant="primary" style="margin-top:35px">Search</b-button>
            </div>
            <div class="form-group col-md-2">
              <b-button
                v-if="show && showbtn"
                variant="warning"
                size="sm"
                @click="scheduleBatch"
                style="margin-top:35px;float:right;margin-righ:10px"
              >Schedule Batch</b-button>
              <b-button
                variant="primary"
                size="sm"
                @click="convertToPdf"
                style="margin-top:35px;float:right;margin-righ:10px"
              >Create PDF</b-button>
              <b-button
                variant="primary"
                size="sm"
                @click="downloadExcel"
                style="margin-top:35px;float:right"
              >Download Excel</b-button>
            </div>
          </div>-->
        </b-form>
      </b-modal>
    </b-form>

    <hr />
    <b-row v-if="isLoading" class="mb-2">
      <b-col class="text-center">
        <b-spinner small class="mr-1"></b-spinner>
        Fetching records...
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col md="3">
        <b-input-group>
          <b-form-input v-model="filter" :debounce="300" placeholder="Type to Search" size="sm" />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''" size="sm">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col md="3">
        <!-- <b-form-group horizontal label="Sort" class="mb-0" label-size="sm" label-cols="1">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-input-group-append>
                  <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group-append>
              </b-input-group>
        </b-form-group>-->
        <p v-if="isLoading">Total Applications: Updating...</p>
        <p v-else>Total Applications: {{totalRows}}</p>
      </b-col>
      <b-col md="3">
        <b-input-group size="sm">
          <b-input-group-prepend is-text>Per page</b-input-group-prepend>
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-input-group>
      </b-col>
      <b-col>
        <b-button
          class="float-right mx-3"
          variant="outline-danger"
          size="sm"
          @click="convertToPdf"
          style="float:right; font-size:1em; color:red"
        >
          <i class="fa fa-file-pdf"></i>
        </b-button>
        <b-button
          variant="outline-success"
          size="sm"
          @click="downloadExcel"
          style="float:right; font-size:1em; color:green"
        >
          <i class="fa fa-file-excel"></i>
        </b-button>
        <b-button
          v-if="show && showbtn"
          variant="warning"
          size="sm"
          @click="scheduleBatch"
          style="float:right"
        >Schedule Batch</b-button>
        <b-button
          v-if="showExtend && (form.ApplicationStatusID==10 || isLoiExtensionStatusId(form.ApplicationStatusID))"
          variant="warning"
          size="sm"
          @click="extendLoi"
          style="float:right;margin-right:10px"
        >Extend LOI</b-button>
      </b-col>
    </b-row>
    <div class="application-results-table">
    <b-table
      id="tblApplication"
      show-empty
      selectable
      select-mode="multi"
      head-variant="dark"
      :empty-text="isLoading ? 'Fetching records...' : 'No Applications available.'"
      stacked="md"
      bordered
      striped
      :items="applications"
      :fields="fields"
      :filter="filter"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      @filtered="onFiltered"
      @row-selected="onRowSelected"
      @sort-changed="onSortChanged"
      style="font-size:12px"
    >
      <template v-slot:cell(selected)="{ rowSelected }">
        <!-- <template slot="selected" slot-scope="row"> -->
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not Selected</span>
        </template>
      </template>
      <template v-slot:cell(Sr)="row">{{((currentPage -1)*perPage) + row.index + 1}}</template>
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click.stop="applyforScheme(row.item, row.index, $event.target,4)"
          class="mr-1 pt-0 pb-0"
          variant="success"
          v-b-tooltip.hover
          title="View Details"
        >View</b-button>
      </template>
      <template v-slot:cell(editDoc)="row">
        <b-button
          size="sm"
          @click.stop="editDocument(row.item, row.index, $event.target,4)"
          class="mr-1 pt-0 pb-0"
          variant="warning"
          v-b-tooltip.hover
          title="Edit Doc"
          v-if="isAdmin"
        >Docs</b-button>
      </template>
    </b-table>
    </div>
    <b-row class="mt-2" v-if="totalRows > 0">
      <b-col class="d-flex justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
          first-number
          last-number
        ></b-pagination>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form @submit="onSubmitBSC" @reset="onReset2" v-if="show && showsts">
          <b-row class="justify-content-md-center">
            <b-col md="9" sm="12" class="mt-2">
              <p style="font-size: 14px;color:#2284ab;">Beneficiary Selection Committee Report</p>
              <p></p>
              <div
                style="padding: 10px;
                                    border: 2px solid #c4c6be;
                                    border-radius: 15px;"
              >
                <div class="row">
                  <b-col md="4">
                    <b-form-group
                      id="exampleInputGroup2"
                      horizontal
                      label="Meeting Date*"
                      label-cols="4"
                      label-size="sm"
                      label-for="inpMtgDate"
                    >
                      <b-form-input
                        id="inpMtgDate"
                        type="date"
                        v-model="formBSC.MeetingDate"
                        required
                        size="sm"
                        placeholder="Meeting Date"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <span
                      class="ln-eng"
                      style="font-size: 0.875rem;"
                    >Beneficiary Selection Committee Report</span>
                  </div>
                  <div class="col-md-4">
                    <b-form-file
                      ref="finp"
                      @change="onFileChange"
                      v-if="bscReportPath ==''"
                      accept=".jpg, .png, .gif"
                      size="sm"
                      required
                      v-model="bscReport"
                      class="mt-3"
                      plain
                    ></b-form-file>
                  </div>
                  <div class="col-md-4" v-if="bscReportPath!=''">
                    <a :href="getImgUrl2(bscReportPath)" target="_blank">
                      <img :src="getImgUrl(bscReportPath)" class="img-fluid" />
                    </a>
                    <b-button
                      size="sm"
                      style="margin-left:0.5rem"
                      @click.stop="deleteDocument2('PhotoPath', bscReportPath)"
                      class="mr-1 pt-0 pb-0"
                      variant="outline-danger"
                      v-b-tooltip.hover
                      title="Delete Document"
                    >
                      <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                    </b-button>
                  </div>
                </div>
                <div class="row mt-2">
                  <b-col md="8">
                    <b-form-group
                      id="exampleInputGroup3"
                      horizontal
                      label="Remarks"
                      label-cols="4"
                      label-size="sm"
                      label-for="inpBscRemarks"
                    >
                      <b-form-textarea
                        id="inpBscRemarks"
                        v-model="formBSC.Remarks"
                        size="sm"
                        rows="2"
                        max-rows="4"
                        placeholder="Remarks"
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2 justify-content-md-center">
            <b-col md="5" sm="12" style="text-align:center">
              <Spinner size="32" message="Loading..." v-if="isLoadingFile"></Spinner>
              <b-alert
                :show="showDismissibleAlert"
                dismissible
                @dismissed="showDismissibleAlert=false"
                :variant="variant"
              >{{alertText}}</b-alert>
            </b-col>
            <b-col md="4" sm="12" style="text-align:right">
              <b-button type="submit" variant="primary" :disabled="!showBtn">Submit</b-button>
              <b-button type="reset" variant="danger">Reset</b-button>
            </b-col>
          </b-row>
        </b-form>
        <b-modal id="modalConfirm" title="Are you sure?" size="sm">
          <pre>{{ modalInfo }}</pre>
          <div slot="modal-footer">
            <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
            <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
          </div>
        </b-modal>
      </b-col>
    </b-row>

    <div>
      <b-modal id="modalConfirm2" title="Schedule Batch" size="sm" hide-footer>
        <pre>Total Applications: {{ appCount }}</pre>
        <b-form @submit="onSubmit3" @reset="onReset3">
          <b-form-group
            id="iGpDt"
            horizontal
            label="Batch Date*"
            label-cols="4"
            label-size="sm"
            label-for="inpBatchDt"
          >
            <b-form-input
              id="inpBatchDt"
              type="date"
              v-model="formBatch.BatchDate"
              required
              size="sm"
              placeholder="Batch Date"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="iGpTm"
            horizontal
            label="Batch Time*"
            label-cols="4"
            label-size="sm"
            label-for="inpBatchTime"
          >
            <b-form-input
              id="inpBatchTime"
              type="time"
              v-model="formBatch.BatchTime"
              required
              size="sm"
              placeholder="Batch Time"
            ></b-form-input>
          </b-form-group>
          <div slot="modal-footer">
            <b-button variant="danger" type="submit" style="margin-left:5px">Create Batch</b-button>
            <b-button variant="info" type="reset" style="margin-left:5px">Reset</b-button>
          </div>
        </b-form>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import { detectTenant, filterByCaste, filterCasteDropdown } from "@/tenantConfig";
import * as _ from "lodash";
import axios from "axios";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import XLSX from "xlsx";
import DatePicker from "vue2-datepicker";
import { normalizeResponseArray } from "@/utils/responseNormalizer";
import store from '../../store'

const APPLICATION_RESULT_CACHE = {};

export default {
  props: ["userDistrictID", "userApprovalStatus", "userLoanType", "statusBucket"],
  components: { Spinner, DatePicker },
  data() {
    return {
      showBtn: false,
      show: false,
      showsts: false,
      showExtend: false,
      isLoading: false,
      applicationsRequestId: 0,
      districtsReadyRefreshDone: false,
      districts: [],
      schemes: [],
      castes: [],
      casteOptionsLoaded: false,
      casteOptionsLoading: null,
      pendingWithList: [
        "All",
        "DM",
        "DBSC",
        "AGM Project",
        "GM",
        "MD",
        "LOI",
        "Lapsed",
        "Disbursed",
        "Hold",
        "Rejected"
      ],
      approvalStatus: [],
      applications: [],
      allApplications: [],
      searchCache: APPLICATION_RESULT_CACHE,
      approvalRemarksCache: {},
      bscReport: "",
      bscReportPath: "",
      appCount: 0,
      appDate: null,
      fields: [
        { key: "selected", label: "Selected" },
        { key: "Sr", label: "SrNo" },
        { key: "DistrictName", label: "District", sortable: true },
        { key: "LoanApplicationNo", label: "Application No", sortable: true },
        {
          key: "Createdate",
          label: "Application Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "AddharCardNumber", label: "Aadhar ID", sortable: true },
        { key: "FullName", label: "Applicant Name", sortable: true },
        { key: "Mobile", label: "Mobile No.", sortable: true },
        { key: "BusinessType", label: "Business Type", sortable: true },
        { key: "AmountDemanded", label: "Amount" },
        { key: "ApplicationStatus", label: "Status", sortable: true },
        { key:"Caste",label:"Caste",sortable: true},
        {
          key: "LastStatusDate",
          label: "Last Action Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "action", label: "View" },
        { key:"editDoc", label: "Doc Edit"}
      ],
      selected: [],
      form: {
        DistrictID: "",
        ApplicationStatusID: 0,
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: "",
        Caste: "",
        StartDate: "01-01-1970",
        EndDate: "01-01-1970"
      },
      formBatch: {
        BatchDate: null,
        BatchTime: null,
        ApplicationIDs: [],
        IsActive: true
      },
      showbtn: false,
      formBSC: {
        BSCID: 0,
        DistrictID: "",
        MeetingDate: null,
        ApprovalStatus: 13,
        ApprovalDoc: "",
        Remarks: "",
        UserID: "",
        ApplicationIDs: []
      },
      selectedApplication: "",
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      maxCacheRows: 2000,
      activeStatusBucket: null,
      pageOptions : [ 50, 100, 150, 200, 500],
      sortBy: null,
      sortDesc: false,
      restoringSortState: false,
      sortStateHydrated: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      modalInfo: "",
      isLoading: false,
      isLoadingFile: false,
      isAdmin:false
    };
  },
  computed: {
    approvalStatusOptions() {
      var bucketKey = String(this.activeStatusBucket || "").toUpperCase();
      if (bucketKey !== "DGM" && bucketKey !== "GM") {
        return this.approvalStatus;
      }

      var targetId = bucketKey === "DGM" ? 4 : 30;
      var targetLabel = bucketKey === "DGM" ? "Recommended by AGM" : "Recommended by DGM";

      return (this.approvalStatus || []).map(status => {
        if (Number(status.Id) !== targetId) {
          return status;
        }

        return Object.assign({}, status, {
          ApplicationStatus: targetLabel
        });
      });
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    userDistrict() {
      return this.$store.getters.getUserDistrict;
    }
  },
  watch: {
    userDistrictId(newvalue, oldvalue) {
      this.form.DistrictID = newvalue;
      this.getApplications();
    },
    $route() {
      const routeStatus =
        this.$route.params.userApprovalStatus !== undefined
          ? this.$route.params.userApprovalStatus
          : this.userApprovalStatus;

      if (routeStatus === undefined || routeStatus === null) {
        return;
      }

      const routeDistrict =
        this.$route.params.userDistrictID !== undefined
          ? this.$route.params.userDistrictID
          : this.userDistrictID;
      const routeLoanType =
        this.$route.params.userLoanType !== undefined
          ? this.$route.params.userLoanType
          : this.userLoanType;
      const routeStatusBucket =
        this.$route.params.statusBucket !== undefined
          ? this.$route.params.statusBucket
          : this.statusBucket;

      this.form.DistrictID = routeDistrict || this.$store.getters.getDistrict;
      this.form.ApplicationStatusID = Number(routeStatus) || 0;
      this.form.LoanType = Number(routeLoanType) || 1;
      this.activeStatusBucket = routeStatusBucket || null;
      this.sortBy = frm && frm._sortBy ? frm._sortBy : null;
      this.sortDesc = !!(frm && frm._sortDesc);

      // GM drilldown always lands on the DGM-recommended filter (status 30);
      // DGM drilldown lands on the AGM-recommended filter (status 4).
      if (
        String(this.activeStatusBucket || "").toUpperCase() === "GM" &&
        (this.form.ApplicationStatusID === 16 || this.form.ApplicationStatusID === 4)
      ) {
        this.form.ApplicationStatusID = 30;
      } else if (
        String(this.activeStatusBucket || "").toUpperCase() === "DGM" &&
        this.form.ApplicationStatusID === 16
      ) {
        this.form.ApplicationStatusID = 4;
      }

      this.getApplicationsSub();
    },
    perPage() {
      this.currentPage = 1;
    }
  },
  methods: {
    persistListState() {
      this.$store.dispatch(
        "setSearchForm",
        Object.assign({}, this.form, {
          _tableFilter: this.filter || "",
          _currentPage: this.currentPage,
          _perPage: this.perPage,
          _sortBy: this.sortBy || null,
          _sortDesc: !!this.sortDesc
        })
      );
    },
    getDefaultStatusForRole(roleId, currentStatus) {
      var normalizedRoleId = Number(roleId || 0);
      var normalizedStatus = Number(currentStatus || 0);

      // GM should land on "Recommended by DGM" when no explicit filter
      // was chosen yet.
      if (normalizedRoleId === 5 && normalizedStatus === 1) {
        return 30;
      }

      return normalizedStatus;
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    onSubmit3(evt) {
      evt.preventDefault();

      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      this.formBatch.LoginID = LoginID;

      //console.log("SELECTED", this.selected);
      for (var i = 0; i < this.selected.length; i++) {
        //loop through the array

        this.formBatch.ApplicationIDs.push(this.selected[i].LoanApplicationID);
      }

      // this.selected.forEach(function(data, index) {
      //   this.formBatch.ApplicationIDs.push(Object.values(data.ApplicationID));
      // });
      let promise = apis.createBatch(this.formBatch);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Batch Created Successfully";
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset3(evt) {},
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    onSubmitBSC(evt) {
      evt.preventDefault();
      this.showBtn = false;
      this.showDismissibleAlert = false;
      if (this.formBSC.ApprovalDoc == "") {
        this.alertText =
          "Approval File is not yet Uploaded. Please check the file icon before submit.";
        this.showDismissibleAlert = true;
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      this.formBSC.UserID = LoginID;
      this.formBSC.DistrictID = this.form.DistrictID;
      this.formBSC.ApplicationIDs = [];

      //console.log("SELECTED", this.selected);

      for (var i = 0; i < this.selected.length; i++) {
        //loop through the array

        this.formBSC.ApplicationIDs.push(this.selected[i].LoanApplicationID);
      }

      //console.log(this.formBSC);
      // this.selected.forEach(function(data, index) {
      //   this.form.ApplicationIDs.push(Object.values(data.ApplicationID));
      // });
      var submittedApplicationIds = this.formBSC.ApplicationIDs.slice();

      let promise = apis.UpdateBSCDetails(this.formBSC);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.variant = "success";
            this.showDismissibleAlert = true;
            this.ResetBSCForm();
            this.removeSubmittedApplicationsFromCurrentList(submittedApplicationIds);
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.showBtn = false;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
          this.showBtn = false;
        });
    },
    onReset2(evt) {
      evt.preventDefault();
    },
    ResetBSCForm() {
      this.$refs.finp.reset();
      this.bscReportPath = "";
      this.formBSC = {
        BSCID: 0,
        DistrictID: "",
        MeetingDate: null,
        ApprovalStatus: 13,
        ApprovalDoc: "",
        Remarks: "",
        UserID: "",
        ApplicationIDs: []
      };
    },
    removeSubmittedApplicationsFromCurrentList(applicationIds) {
      var lookup = {};
      (applicationIds || []).forEach(id => {
        var key = String(id || "").trim();
        if (key) {
          lookup[key] = true;
        }
      });

      if (Object.keys(lookup).length === 0) {
        return;
      }

      var keepRow = row => !lookup[String((row && row.LoanApplicationID) || "").trim()];
      this.allApplications = (this.allApplications || []).filter(keepRow);
      this.applications = (this.applications || []).filter(keepRow);
      this.totalRows = this.applications.length;
      this.currentPage = 1;
      this.selected = [];
      delete this.searchCache[this.getSearchCacheKey()];

      if (this.$refs.selectableTable && this.$refs.selectableTable.clearSelected) {
        this.$refs.selectableTable.clearSelected();
      }
    },
    deleteDocument(item, index, button) {
      //console.log(item);
      this.selecteObj.Document = item.Document;
      this.selecteObj.Path = item.Path;

      let info = "You want to delete record for:" + "\n" + item.Document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    scheduleBatch() {
      this.appCount = this.selected.length;
      if (this.appCount == 0) {
        alert("Please select Applications for Scheduling");
        return;
      }
      this.$root.$emit("bv::show::modal", "modalConfirm2");
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      this.isLoadingFile = true;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.finp.reset();
        this.isLoadingFile = false;
        return;
      }

      let dt = Date.now();
      var filetype = files[0].type;
      var filepath = "msobcfdc_bsc"+"!!~~!!"+"bsc_" + dt + "." + extn;
      var orignalfilepath="bsc_" + dt + "." + extn;
     // let promisefoto = lambda.getSignedURL("msobcfdc_bsc", filepath, filetype);
      let data = new FormData();
      let file = e.target.files[0];

      data.append('file', file,filepath);
      // promisefoto
      //   .then(response => {
      //     let signedUrl = response;
      //     var options = {
      //       headers: {
      //         "Access-Control-Allow-Origin": "*",
      //         "Content-Type": files[0].type
      //       }
      //     };
      //     return axios.put(signedUrl, files[0], options);
      //   })
      let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
      axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.formBSC.ApprovalDoc = orignalfilepath;
            this.showBtn = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoadingFile = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoadingFile = false;
        });
    },
    applyforScheme(item, index, button, n) {
      this.persistListState();
      this.$store.dispatch("setScheme", {
        SchemeID: item.SchemType,
        LoanType: item.LoanType,
        GroupID: item.GroupID
      });
      if (item.LoanType == 1) {
        this.$router.push({
          name: "ProfileApproval",
          params: {
            UserID: item.UserID,
            ApplicationStatus: this.form.ApplicationStatusID,
            userDistrictID: this.form.DistrictID,
            userApprovalStatus: this.form.ApplicationStatusID,
            userLoanType: this.form.LoanType,
            statusBucket: this.activeStatusBucket || ""
          }
        });
      } else if (item.LoanType == 2) {
        this.$router.push({
          name: "GroupProfileApproval",
          params: {
            UserID: item.UserID,
            ApplicationStatus: this.form.ApplicationStatusID,
            userDistrictID: this.form.DistrictID,
            userApprovalStatus: this.form.ApplicationStatusID,
            userLoanType: this.form.LoanType,
            statusBucket: this.activeStatusBucket || ""
          }
        });
      } else if (item.LoanType == 3) {
        this.$router.push({
          name: "ProfileApproval",
          params: {
            UserID: item.UserID,
            ApplicationStatus: this.form.ApplicationStatusID,
            userDistrictID: this.form.DistrictID,
            userApprovalStatus: this.form.ApplicationStatusID,
            userLoanType: this.form.LoanType,
            statusBucket: this.activeStatusBucket || ""
          }
        });
      }
    },
    editDocument(item, index, button, n){
      this.persistListState();
      this.$router.push({
        name:"DocEdit",
        params: {
            UserID: item.UserID,
            ApplicationStatus: this.form.ApplicationStatusID
          }
      })
    },
    getSearchCacheKey() {
      return JSON.stringify({
        tenant: detectTenant(),
        statusBucket: this.activeStatusBucket || "",
        DistrictID: this.form.DistrictID || "",
        ApplicationStatusID: this.form.ApplicationStatusID || 0,
        LoanType: this.form.LoanType || 1,
        MobileNo: this.form.MobileNo || "",
        ApplicationNo: this.form.ApplicationNo || "",
        Caste: this.form.Caste || "",
        StartDate: this.form.StartDate || "",
        EndDate: this.form.EndDate || ""
      });
    },

    applyCachedSearchResult(cacheEntry) {
      if (!cacheEntry) {
        return;
      }

      this.allApplications = Array.isArray(cacheEntry.allApplications) ? cacheEntry.allApplications : [];
      this.applications = Array.isArray(cacheEntry.applications) ? cacheEntry.applications : [];
      this.totalRows = Number(cacheEntry.totalRows || this.applications.length || 0);
      this.currentPage = 1;
      this.$nextTick(() => {
        this.sortStateHydrated = true;
      });
    },

    clearApplicationsData() {
      this.allApplications = [];
      this.applications = [];
      this.totalRows = 0;
      this.currentPage = 1;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onSortChanged(context) {
      if (this.restoringSortState || !this.sortStateHydrated) {
        return;
      }
      if ((!context || !context.sortBy) && this.sortBy) {
        return;
      }
      this.sortBy = context && context.sortBy ? context.sortBy : null;
      this.sortDesc = !!(context && context.sortDesc);
      this.persistListState();
    },

    loadMoreApplications() {},

    resetVisibleApplications() {
      this.currentPage = 1;
    },
    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;
            this.districts.unshift({
              DistID: "00000000-0000-0000-0000-000000000000",
              DistName: "All"
            });

            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getApprovalStatus() {
      let promise = apis.getApplicationStatusMstr();
      promise
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.approvalStatus = this.getDashboardStatusOptions(response.body);
          } else {
            this.alertText =
              "Unable to Load Approval Status List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText =
            "Unable to Load Approval Status List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    getDefaultCasteOptions() {
      return [
        {
          CasteID: "",
          CasteName: "All"
        }
      ];
    },
    getCasteCacheKey() {
      return "applications_caste_dropdown_" + detectTenant();
    },
    ensureCasteOptionsLoaded(forceReload) {
      if (this.casteOptionsLoaded && !forceReload) {
        return Promise.resolve(this.castes);
      }

      if (this.casteOptionsLoading && !forceReload) {
        return this.casteOptionsLoading;
      }

      var cacheKey = this.getCasteCacheKey();
      if (!forceReload) {
        var cached = sessionStorage.getItem(cacheKey);
        if (cached) {
          try {
            var parsed = JSON.parse(cached);
            if (Array.isArray(parsed) && parsed.length > 0) {
              this.castes = parsed;
              this.casteOptionsLoaded = true;
              return Promise.resolve(this.castes);
            }
          } catch (e) {
            sessionStorage.removeItem(cacheKey);
          }
        }
      }

      var currentTenant = detectTenant();
      this.casteOptionsLoading = apis
        .getCaste()
        .then(response => {
          if (response.status == 200) {
            var filtered = filterCasteDropdown(response.body, currentTenant).filter(item => {
              return item && item.CasteName && item.CasteName.toString().trim() !== "";
            });

            this.castes = this.getDefaultCasteOptions().concat(filtered);
            this.casteOptionsLoaded = true;
            sessionStorage.setItem(cacheKey, JSON.stringify(this.castes));
            return this.castes;
          }

          this.alertText = "Unable to Load Caste List, " + response.body;
          this.variant = "warning";
          this.showDismissibleAlert = true;
          this.castes = this.getDefaultCasteOptions();
          return this.castes;
        })
        .catch(err => {
          this.alertText = "Unable to Load Caste List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.castes = this.getDefaultCasteOptions();
          return this.castes;
        })
        .finally(() => {
          this.casteOptionsLoading = null;
        });

      return this.casteOptionsLoading;
    },
    getCaste() {
      return this.ensureCasteOptionsLoaded(false);
    },
    getSchemes() {
      let promise = apis.getSchemes();

      promise
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.schemes = response.body;
          } else {
            this.alertText = "Unable to Load Scheme List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = "Unable to Load Scheme List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    getDashboardStatusOptions(statuses) {
      var bucketKey = String(this.activeStatusBucket || "").toUpperCase();
      if (bucketKey !== "DGM" && bucketKey !== "GM") {
        return statuses;
      }

      var targetId = bucketKey === "DGM" ? 4 : 30;
      var targetLabel = bucketKey === "DGM" ? "Recommended by AGM" : "Recommended by DGM";

      return (statuses || []).map(status => {
        if (Number(status.Id) !== targetId) {
          return status;
        }

        return Object.assign({}, status, {
          ApplicationStatus: targetLabel
        });
      });
    },
    onSubmit(evt) {
      evt.preventDefault();

      if (this.isLoading) {
        return;
      }

      // Explicit search from this screen should use exact status filter.
      this.activeStatusBucket = null;

      if (this.appDate != null) {
        this.form.StartDate = Formatter.convertDateFormatYMD(this.appDate[0]);
        this.form.EndDate = Formatter.convertDateFormatYMD(this.appDate[1]);
      } else {
        // Use a wide valid range so the SP date filter covers all real applications.
        // "0001-01-01" is out-of-range for SQL Server datetime and returns 0 rows.
        this.form.StartDate = "1970-01-01";
        this.form.EndDate = "2999-12-31";
      }

      this.getApplicationsSub();
    },

    getApplications() {
      //let userDistrict = this.$store.getters.getUserDistrict;
      if (
        !this.form.DistrictID &&
        this.userDistrict != "00000000-0000-0000-0000-000000000000"
      ) {
        this.form.DistrictID = this.userDistrict;
      }
      // else {
      //   this.form.DistrictID = this.$store.getters.getDistrict;
      // }
      // this.form.LoanType = this.$store.getters.getLoanType;
      // this.form.ApplicationStatusID = this.$router.params.userLoanType;
      this.getApplicationsSub();
    },

    normalizeCasteText(value) {
      var text = (value || "").toString().trim().toLowerCase();
      if (!text) {
        return "";
      }

      var dashIndex = text.indexOf("-");
      if (dashIndex > 0) {
        text = text.substring(dashIndex + 1).trim();
      }

      return text;
    },

    resolveSelectedDistrictName() {
      var selectedDistrictId = String(this.form.DistrictID || "").trim();
      if (!selectedDistrictId || selectedDistrictId === "00000000-0000-0000-0000-000000000000") {
        return "";
      }

      var district = (this.districts || []).find(item => String(item.DistID) === selectedDistrictId);
      return district && district.DistName ? district.DistName.toString().trim().toLowerCase() : "";
    },

    applySelectedDistrictFilter(apps) {
      if (!Array.isArray(apps) || apps.length === 0) {
        return [];
      }

      var selectedDistrictId = String(this.form.DistrictID || "").trim();
      if (!selectedDistrictId || selectedDistrictId === "00000000-0000-0000-0000-000000000000") {
        return apps;
      }

      var selectedDistrictName = this.resolveSelectedDistrictName();

      // Dashboard drilldown can hit this before district master data is
      // loaded. Do not apply strict name-based filtering yet.
      if (!selectedDistrictName && (!this.districts || this.districts.length === 0)) {
        return apps;
      }

      var filtered = apps.filter(app => {
        var rowDistrictId = String(app.DistrictID || app.DistrictId || app.DistID || "").trim();
        if (rowDistrictId && rowDistrictId === selectedDistrictId) {
          return true;
        }

        if (!selectedDistrictName) {
          return false;
        }

        var rowDistrictName = (app.DistrictName || app.District || app.DistName || "").toString().trim().toLowerCase();
        return rowDistrictName === selectedDistrictName;
      });

      // Keep fallback only for datasets that carry no district metadata at all.
      var hasAnyDistrictMetadata = apps.some(app => {
        var rowDistrictId = String(app.DistrictID || app.DistrictId || app.DistID || "").trim();
        var rowDistrictName = (app.DistrictName || app.District || app.DistName || "").toString().trim();
        return !!rowDistrictId || !!rowDistrictName;
      });

      return hasAnyDistrictMetadata ? filtered : apps;
    },

    getSelectedStatusText(statusId) {
      var matched = (this.approvalStatus || []).find(item => String(item.Id) === String(statusId));
      return matched && matched.ApplicationStatus
        ? matched.ApplicationStatus.toString().trim().toLowerCase()
        : "";
    },

    casteCandidateNames(app) {
      return [
        app.CasteName,
        app.Caste,
        app.CasteMarathi,
        app.CasteEnglish,
        app.SubCaste,
        app.SubCasteName,
        app.Category,
        app.CategoryName
      ];
    },

    casteCandidateIds(app) {
      return [
        app.CasteID,
        app.CasteId,
        app.CasteCode,
        app.SubCasteID,
        app.SubCasteCode,
        app.CategoryID,
        app.CategoryId
      ];
    },

    // True only when the loaded records actually expose a caste field we can
    // match against. ReadApplicationList returns a lean projection for some
    // portals (no caste column), in which case client-side caste filtering is
    // impossible and we must defer to the server-side filter instead.
    recordsCarryCasteData(apps) {
      return apps.some(app => {
        var hasName = this.casteCandidateNames(app).some(
          name => this.normalizeCasteText(name) !== ""
        );
        var hasId = this.casteCandidateIds(app).some(
          id => id !== undefined && id !== null && String(id).trim() !== ""
        );
        return hasName || hasId;
      });
    },

    applySelectedCasteFilter(apps) {
      if (!Array.isArray(apps) || apps.length === 0) {
        return [];
      }

      if (!this.form.Caste) {
        return apps;
      }

      // If the records don't carry caste data, the backend has already applied
      // the caste filter for us. Filtering further on a missing field would
      // wipe every valid row, so leave the server result untouched.
      if (!this.recordsCarryCasteData(apps)) {
        return apps;
      }

      var selectedCaste = this.castes.find(
        item => String(item.CasteID) === String(this.form.Caste)
      );

      var selectedName = selectedCaste ? selectedCaste.CasteName : "";
      var normalizedSelectedName = this.normalizeCasteText(selectedName);
      var selectedId = String(this.form.Caste);

      return apps.filter(app => {
        var hasMatchingName = this.casteCandidateNames(app).some(name => {
          var normalizedName = this.normalizeCasteText(name);
          if (!normalizedName || !normalizedSelectedName) {
            return false;
          }

          return (
            normalizedName === normalizedSelectedName ||
            normalizedName.indexOf(normalizedSelectedName) !== -1 ||
            normalizedSelectedName.indexOf(normalizedName) !== -1
          );
        });

        var hasMatchingId = this.casteCandidateIds(app).some(
          id => String(id) === selectedId
        );

        return hasMatchingName || hasMatchingId;
      });
    },

    applyCurrentFiltersToLoadedApplications() {
      var districtFiltered = this.applySelectedDistrictFilter(this.allApplications);
      this.applications = this.applySelectedCasteFilter(districtFiltered);
      this.totalRows = this.applications.length;
      this.currentPage = 1;
    },

    getRowStatusId(app) {
      var statusId = parseInt(
        app._ResolvedApplicationStatusID || app.ApplicationStatusID || app.ApplicationStatusId || app.StatusID || app.AppStatusID || app.ApprovalStatusID || 0,
        10
      );
      return Number.isNaN(statusId) ? 0 : statusId;
    },

    getRowStatusText(app) {
      return this.normalizeStatusText(
        app.ApplicationStatus || app.Status || app.ApplicationStatus1 || app.ApprovalStatus || ""
      );
    },

    normalizeStatusText(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ")
        .replace(/progeje|projeje|progect|projec\b/g, "project");
    },

    getStatusLabel(statusId) {
      var matched = (this.approvalStatus || []).find(item => Number(item.Id) === Number(statusId));
      return matched && matched.ApplicationStatus ? matched.ApplicationStatus : "";
    },

    getLoiExtensionGenericStatusMap() {
      return {
        4: 24,
        30: 32,
        16: 27,
        6: 21
      };
    },

    getLoiExtensionLookupStatusMap() {
      return {
        24: 4,
        32: 30,
        27: 16,
        21: 6
      };
    },

    isLoiExtensionStatusId(statusId) {
      return [21, 23, 24, 25, 26, 27, 28, 29, 32, 33, 34].indexOf(Number(statusId)) !== -1;
    },

    hasLoiExtensionHistory(remarks) {
      return (Array.isArray(remarks) ? remarks : []).some(item => {
        return this.normalizeStatusText(item && item.ApplicationStatus || "").indexOf("loi extension") !== -1;
      });
    },

    getApplicationStatusIdFromText(app) {
      var rowStatusText = this.getRowStatusText(app || {});
      var matched = (this.approvalStatus || []).find(item => {
        return this.normalizeStatusText(item.ApplicationStatus || "") === rowStatusText;
      });
      return matched ? Number(matched.Id) : 0;
    },

    shouldCheckLoiExtensionHistory(app, selectedStatusId) {
      var statusId = this.getRowStatusId(app || {}) || this.getApplicationStatusIdFromText(app || {});
      var genericMap = this.getLoiExtensionGenericStatusMap();
      var lookupMap = this.getLoiExtensionLookupStatusMap();

      if (genericMap[statusId]) {
        return true;
      }

      return !!lookupMap[Number(selectedStatusId || 0)];
    },

    getApprovalRemarksForApplication(applicationId) {
      var key = String(applicationId || "").trim();
      if (!key) {
        return Promise.resolve([]);
      }

      if (this.approvalRemarksCache[key]) {
        return Promise.resolve(this.approvalRemarksCache[key]);
      }

      return apis.ReadApprovalRemarks(key).then(response => {
        var rows = response && response.status == 200 && Array.isArray(response.body) ? response.body : [];
        this.approvalRemarksCache[key] = rows;
        return rows;
      }).catch(() => []);
    },

    applyLoiExtensionStatus(row, remarks) {
      if (!this.hasLoiExtensionHistory(remarks)) {
        return row;
      }

      var genericStatusId = this.getRowStatusId(row || {}) || this.getApplicationStatusIdFromText(row || {});
      var extensionStatusId = this.getLoiExtensionGenericStatusMap()[genericStatusId];
      if (!extensionStatusId) {
        return row;
      }

      return Object.assign({}, row, {
        _OriginalApplicationStatus: row.ApplicationStatus,
        _OriginalApplicationStatusID: genericStatusId,
        _ResolvedApplicationStatusID: extensionStatusId,
        ApplicationStatus: this.getStatusLabel(extensionStatusId) || row.ApplicationStatus
      });
    },

    applyLoiExtensionStatuses(rows, selectedStatusId) {
      var list = Array.isArray(rows) ? rows : [];
      var candidates = list.filter(row => this.shouldCheckLoiExtensionHistory(row, selectedStatusId));
      if (candidates.length === 0) {
        return Promise.resolve(list);
      }

      return Promise.all(
        list.map(row => {
          if (!this.shouldCheckLoiExtensionHistory(row, selectedStatusId)) {
            return Promise.resolve(row);
          }

          return this.getApprovalRemarksForApplication(row.LoanApplicationID).then(remarks => {
            return this.applyLoiExtensionStatus(row, remarks);
          });
        })
      );
    },

    getAllowedStatusTextLookup(statusList) {
      var lookup = {};
      if (!Array.isArray(statusList) || statusList.length === 0) {
        return lookup;
      }

      var statusMaster = Array.isArray(this.approvalStatus) ? this.approvalStatus : [];
      statusList.forEach(statusId => {
        var matched = statusMaster.find(item => String(item.Id) === String(statusId));
        var text = matched && matched.ApplicationStatus
          ? this.normalizeStatusText(matched.ApplicationStatus)
          : "";
        if (text) {
          lookup[text] = true;
        }
      });

      return lookup;
    },

    applyStrictStatusIdFilter(apps, statusList) {
      if (!Array.isArray(apps) || apps.length === 0) {
        return [];
      }

      var allowedStatuses = Array.isArray(statusList)
        ? statusList
            .map(id => parseInt(id, 10))
            .filter(id => !Number.isNaN(id) && id > 0)
        : [];

      if (allowedStatuses.length === 0) {
        return apps;
      }

      var allowedLookup = {};
      allowedStatuses.forEach(id => {
        allowedLookup[id] = true;
      });
      var allowedStatusTextLookup = this.getAllowedStatusTextLookup(allowedStatuses);

      return apps.filter(app => {
        var rowStatusId = this.getRowStatusId(app || {});
        var rowStatusText = this.getRowStatusText(app || {});

        if (rowStatusId) {
          if (allowedLookup[rowStatusId] !== true) {
            return false;
          }

          // Guard against backend rows where status id and status text drift.
          if (rowStatusText && Object.keys(allowedStatusTextLookup).length > 0) {
            return allowedStatusTextLookup[rowStatusText] === true;
          }
          return true;
        }

        // Some deployments return a lean row projection without StatusID.
        // In that case, allow only rows whose status text matches selected statuses.
        if (!rowStatusText) {
          return false;
        }
        return allowedStatusTextLookup[rowStatusText] === true;
      });
    },

    alignStatusFilterWithLoadedRows(rows) {
      const bucketKey = String(this.activeStatusBucket || "").toUpperCase();
      // Only the GM bucket auto-aligns to the DGM-recommended filter; the DGM
      // bucket should stay on the AGM-recommended filter (status 4).
      if (bucketKey !== "GM") {
        return;
      }

      var currentStatusId = Number(this.form && this.form.ApplicationStatusID || 0);
      if (currentStatusId !== 16 && currentStatusId !== 4) {
        return;
      }

      var list = Array.isArray(rows) ? rows : [];
      if (list.length === 0) {
        return;
      }

      var dgmRecommendedCount = 0;
      var gmApprovedCount = 0;

      list.forEach(row => {
        var text = this.getRowStatusText(row || {});
        if (!text) return;

        if (text.indexOf("recommended by dgm") !== -1) {
          dgmRecommendedCount += 1;
        }
        if (text.indexOf("approved by gm") !== -1) {
          gmApprovedCount += 1;
        }
      });

      // If drilldown rows are DGM recommendation stage, keep dropdown aligned.
      if (dgmRecommendedCount > 0 && gmApprovedCount === 0) {
        this.form.ApplicationStatusID = 30;
        this.activeStatusBucket = "DGM";
      }
    },

    syncStatusDropdownWithVisibleRows() {
      const currentStatusId = Number(this.form && this.form.ApplicationStatusID || 0);
      const bucketKey = String(this.activeStatusBucket || "").toUpperCase();
      // Only the GM bucket auto-aligns to the DGM-recommended filter; the DGM
      // bucket should stay on the AGM-recommended filter (status 4).
      const isDgmDrilldown = bucketKey === "GM";

      if (!isDgmDrilldown) {
        return;
      }

      var list = Array.isArray(this.applications) ? this.applications : [];
      if (list.length === 0) {
        return;
      }

      var dgmRecommendedCount = 0;
      list.forEach(row => {
        var text = this.getRowStatusText(row || {});
        if (text && text.indexOf("recommended by dgm") !== -1) {
          dgmRecommendedCount += 1;
        }
      });

      if (dgmRecommendedCount > 0 && currentStatusId !== 30) {
        this.form.ApplicationStatusID = 30;
        this.activeStatusBucket = "DGM";
      }
    },

    onCasteChange() {
      // Re-query the server so the backend caste filter is applied. The
      // response is then narrowed further client-side by
      // applySelectedCasteFilter (a no-op when records carry no caste field).
      this.getApplicationsSub();
    },

    onStatusFilterChange() {
      // Manual selection must clear any dashboard drilldown bucket.
      this.activeStatusBucket = null;
      this.getApplicationsSub();
    },

    shouldCacheCurrentResult(rows) {
      return Array.isArray(rows) && rows.length > 0 && rows.length <= this.maxCacheRows;
    },

    getStatusFilterList(statusId) {
      var id = Number(statusId || 0);

      var statusBuckets = {
        DM: [1, 5, 15],
        DBSC: [2],
        PROJECT: [13, 17, 19, 23, 26, 28, 33],
        DGM: [4, 24, 30, 31, 32, 33, 34],
        GM: [16, 17, 27, 28],
        MD: [6],
        LOI: [6, 8, 9, 16, 21, 22, 27],
        LAPSED: [10, 25, 29],
        DISBURSED: [22],
        HOLD: [3],
        REJECTED: [7, 14, 18],
        TOTAL: [0]
      };

      // Apply grouped status when navigating from MIS bucket.
      if (this.activeStatusBucket) {
        var bucketKey = String(this.activeStatusBucket).toUpperCase();
        if (statusBuckets[bucketKey]) {
          return statusBuckets[bucketKey];
        }
      }

      // For rejection-type statuses (Rejected by MD=7, Rejected by DBSC=14,
      // Rejected by DM=18), always expand to the full REJECTED bucket so the
      // result matches the MIS summary "Rejected" column which groups all three.
      if (statusBuckets.REJECTED.indexOf(id) !== -1) {
        return statusBuckets.REJECTED;
      }

      // The LOI dashboard total includes every valid LOI lifecycle stage,
      // not just the legacy "LOI Printed" status id (8).
      if (statusBuckets.LOI.indexOf(id) !== -1) {
        return statusBuckets.LOI;
      }

      var extensionLookupStatusMap = this.getLoiExtensionLookupStatusMap();
      if (extensionLookupStatusMap[id]) {
        return [id, extensionLookupStatusMap[id]];
      }

      return [id];
    },

    mergeApplicationRows(rows) {
      var merged = [];
      var seen = {};

      rows.forEach(row => {
        var key = row && row.LoanApplicationID ? String(row.LoanApplicationID) : "";
        if (!key) {
          return;
        }

        if (!seen[key]) {
          seen[key] = true;
          merged.push(row);
        }
      });

      return merged;
    },

    getApplicationsSub() {
      const requestId = ++this.applicationsRequestId;
      const cacheKey = this.getSearchCacheKey();
      const cachedResult = this.searchCache[cacheKey];

      if (cachedResult) {
        this.applyCachedSearchResult(cachedResult);
      } else {
        this.clearApplicationsData();
      }

      this.isLoading = !cachedResult;
      this.showDismissibleAlert = false;

      if (this.form.ApplicationStatusID == 2) {
        this.showsts = true;
      } else {
        this.showsts = false;
      }

      if (this.form.ApplicationStatusID == 1) {
        this.showbtn = true;
      } else {
        this.showbtn = false;
      }

      // Caste filter is hidden in UI, so force-clear to avoid stale state
      // silently filtering valid records.
      this.form.Caste = "";

      this.persistListState();
      const tenant = detectTenant();
      var statusList = this.getStatusFilterList(this.form.ApplicationStatusID);

      var requests = statusList.map(statusId => {
        var selectedDistrictId = String(this.form.DistrictID || "").trim();
        var allDistrictId = "00000000-0000-0000-0000-000000000000";
        var isGroupLoan = Number(this.form.LoanType) === 2;

        var requestFilter = Object.assign({}, this.form, {
          ApplicationStatusID: statusId,
          Caste: ""
        });

        // Backend district filtering for Group Loan is inconsistent in some DB
        // branches. Fetch by status and filter district on client reliably.
        if (isGroupLoan && selectedDistrictId && selectedDistrictId !== allDistrictId) {
          requestFilter.DistrictID = allDistrictId;
        }

        return apis.ReadApplicationList(requestFilter);
      });

      Promise.all(requests)
        .then(responses => {
          if (requestId !== this.applicationsRequestId) {
            return;
          }

          var rows = [];
          var failedResponseCount = 0;

          responses.forEach(response => {
            if (!response || response.status != 200) {
              failedResponseCount += 1;
              return;
            }
            rows = rows.concat(normalizeResponseArray(response));
          });

          if (rows.length > 0) {
            var tenantRows = filterByCaste(this.mergeApplicationRows(rows), tenant);
            tenantRows = this.applyStrictStatusIdFilter(tenantRows, statusList);
            return this.applyLoiExtensionStatuses(tenantRows, this.form.ApplicationStatusID).then(normalizedRows => {
              if (requestId !== this.applicationsRequestId) {
                return;
              }

              tenantRows = this.applyStrictStatusIdFilter(normalizedRows, [this.form.ApplicationStatusID]);
              this.alignStatusFilterWithLoadedRows(tenantRows);
              this.allApplications = tenantRows;
              this.applyCurrentFiltersToLoadedApplications();
              this.syncStatusDropdownWithVisibleRows();
              this.$nextTick(() => {
                this.sortStateHydrated = true;
              });

              if (this.shouldCacheCurrentResult(this.allApplications)) {
                this.searchCache[cacheKey] = {
                  allApplications: this.allApplications,
                  applications: this.applications,
                  totalRows: this.totalRows
                };
              }

              if (this.totalRows === 0 && Number(this.form.ApplicationStatusID) > 0) {
                this.alertText =
                  "No applications found for selected status and filters.";
                this.variant = "warning";
                this.showDismissibleAlert = true;
              }
              if (failedResponseCount > 0) {
                this.alertText = "Some status buckets failed to load, showing available results.";
                this.variant = "warning";
                this.showDismissibleAlert = true;
              }
              var userinfo = this.$store.getters.loggedUser;
              if ((this.form.ApplicationStatusID == 10 || this.form.ApplicationStatusID == 23 || this.isLoiExtensionStatusId(this.form.ApplicationStatusID)) && (userinfo.RoleID == 3 || userinfo.RoleID == 4 || userinfo.RoleID == 5 || userinfo.RoleID == 6 || userinfo.RoleID == 10)) {
                this.showExtend = true;
              } else {
                this.showExtend = false;
              }
            });
          } else {
            this.allApplications = [];
            this.applications = [];
            this.totalRows = 0;
            this.alertText = "No applications found for selected status and filters.";
            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.showExtend = false;
          }
        })
        .catch(err => {
          if (requestId !== this.applicationsRequestId) {
            return;
          }

          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        })
        .finally(() => {
          if (requestId === this.applicationsRequestId) {
            this.isLoading = false;
          }
        });

      if (this.$refs.mdlAdvSearch && this.$refs.mdlAdvSearch.hide) {
        this.$refs.mdlAdvSearch.hide();
      }
      //console.log(this.selectedDistrict);
    },
    onReset(evt) {
      evt.preventDefault();
      this.activeStatusBucket = null;
      this.form = {
        DistrictID: "",
        ApplicationStatusID: 0,
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: "",
        Caste: "",
        StartDate: null,
        EndDate: null
      };
    },
    convertToPdf() {
      var pdf = new jsPDF("l", "pt");
      var columns = [
        { dataKey: "DistrictName", title: "District" },
        { dataKey: "LoanApplicationNo", title: "Application No" },
        {
          dataKey: "Createdate",
          title: "Application Date"
        },
        { dataKey: "BusinessType", title: "Business Type" },
        { dataKey: "AddharCardNumber", title: "Aadhar ID" },
        { dataKey: "FullName", title: "Applicant Name" },
        { dataKey: "Mobile", title: "Mobile No." },
        { dataKey: "AmountDemanded", title: "Amount" },
        { dataKey: "ApplicationStatus", title: "Status" }
      ];
      pdf.text("MSOBCFDC Loan Applications", 25, 30);
      var vc = this;
      pdf.autoTable(columns, vc.applications, {
        didParseCell(data) {
          if (data.cell.section != "head") {
            switch (data.column.dataKey) {
              case "Createdate":
                data.cell.text = vc.convertDateFormat(data.cell.text);
                break;
            }
          }
        }
      });
      pdf.save("Applications.pdf");
    },
    async downloadExcel() {
      var columns = [
        "District",
        "Application No",
        "Application Date",
        "Business Type",
        "Aadhar ID",
        "Applicant Name",
        "Mobile No.",
        "Amount",
        "Status",
        "Last Action Date"
      ];

      let app_data = [];

      for (const element of this.applications) {
        let obj = {
          District: "",
          "Application No": "",
          "Application Date": null,
          "Business Type": null,
          "Aadhar ID": "",
          "Applicant Name": "",
          "Mobile No.": "",
          Amount: 0,
          Status: ""
        };

        obj.District = element.DistrictName;
        obj["Application No"] = element.LoanApplicationNo;
        obj["Application Date"] = this.convertDateFormat(element.Createdate);
        obj["Aadhar ID"] = element.AddharCardNumber;
        obj["Applicant Name"] = this.titleCase(element.FullName);
        obj["Business Type"] = this.titleCase(element.BusinessType);
        obj["Mobile No."] = element.Mobile;
        obj["Amount"] = element.AmountDemanded;
        obj["Status"] = element.ApplicationStatus;
        obj["Last Action Date"] = this.convertDateFormat(
          element.LastStatusDate
        );

        app_data.push(obj);
      }

      var vc = this;
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(app_data, { header: columns });
      ws["!cols"] = [
        { wpx: 125 },
        { wpx: 180 },
        { wpx: 120 },
        { wpx: 105 },
        { wpx: 105 },
        { wpx: 220 },
        { wpx: 90 },
        { wpx: 70 },
        { wpx: 70 }
      ];
      XLSX.utils.book_append_sheet(wb, ws, "Applications");
      XLSX.writeFile(wb, "Application.xlsx");
    },
    titleCase(str) {
      if ((str != null) & (str != undefined)) {
        return str
          .trim()
          .toLowerCase()
          .split(" ")
          .map(function(word) {
            if (word) {
              return word.replace(word[0], word[0].toUpperCase());
            } else {
              return "";
            }
          })
          .join(" ");
      }
    },
    extendLoi(evt) {
      evt.preventDefault();
      if (this.selected.length == 0) {
        this.$dialog.alert("Please select application");
        return;
      }
      var appform = {
        ApplicationIDs: [],
        CreatedUser: this.$store.getters.loggedUser.UserId
      };

      for (var i = 0; i < this.selected.length; i++) {
        appform.ApplicationIDs.push(this.selected[i].LoanApplicationID);
      }
      var t = this;
      this.$dialog
        .prompt(
          {
            title: "Confirm LOI Extension",
            body:
              "A New LOI will be issued for the selected Application(s), Do you want to Continue?"
          },
          {
            promptHelp: 'Provide Remarks and click "[+:okText]"',
            okText: "Extend LOI",
            cancelText: "Cancel",
            loader: false
          }
        )
        .then(function(dialog) {
          if (dialog.data) {
            appform.remarks = dialog.data;
          } else {
            t.$dialog.alert("Please enter Remarks");
            return;
          }
          return apis.ExtendLoi(appform);
        })
        .then(response => {
          if (response != undefined) {
            if (response.status == 200) {
              this.$dialog.alert(
                "New LOI Issued for the Selected Applications"
              );
              t.removeSubmittedApplicationsFromCurrentList(appform.ApplicationIDs);
            } else {
              this.$dialog.alert("Unable to save changes");
            }
          }
        })
        .catch(err => {
          if (err != false) {
            this.$dialog.alert("Error while saving data");
          }
        });
    }
  },
  mounted() {
    let frm = this.$store.getters.getAppSearchForm;
    var routeStatus =
      this.$route.params.userApprovalStatus !== undefined
        ? this.$route.params.userApprovalStatus
        : this.userApprovalStatus;
    var routeDistrict =
      this.$route.params.userDistrictID !== undefined
        ? this.$route.params.userDistrictID
        : this.userDistrictID;
    var routeLoanType =
      this.$route.params.userLoanType !== undefined
        ? this.$route.params.userLoanType
        : this.userLoanType;
    var routeStatusBucket =
      this.$route.params.statusBucket !== undefined
        ? this.$route.params.statusBucket
        : this.statusBucket;
    var hasRouteFilter = routeStatus !== undefined && routeStatus !== null;

    if (hasRouteFilter) {
      this.form.DistrictID = routeDistrict || this.$store.getters.getDistrict;
      this.form.ApplicationStatusID = Number(routeStatus) || 0;
      this.form.LoanType = Number(routeLoanType) || 1;
      this.activeStatusBucket = routeStatusBucket || null;
      this.sortBy = frm && frm._sortBy ? frm._sortBy : null;
      this.sortDesc = !!(frm && frm._sortDesc);

      // Backward compatibility: some drilldowns still send GM status id while
      // intent is DGM (status 4) or GM (status 30) recommendation bucket.
      if (
        String(this.activeStatusBucket || "").toUpperCase() === "GM" &&
        (this.form.ApplicationStatusID === 16 || this.form.ApplicationStatusID === 4)
      ) {
        this.form.ApplicationStatusID = 30;
      } else if (
        String(this.activeStatusBucket || "").toUpperCase() === "DGM" &&
        this.form.ApplicationStatusID === 16
      ) {
        this.form.ApplicationStatusID = 4;
      }

      this.form.MobileNo = "";
      this.form.ApplicationNo = "";
      this.form.Caste = "";
      this.form.StartDate = "1970-01-01";
      this.form.EndDate = "2999-12-31";
      this.appDate = null;
    } else if (frm && Object.keys(frm).length > 0 && frm.ApplicationStatusID != undefined) {
      this.form = Object.assign({}, frm);
      this.filter = frm._tableFilter || "";
      this.currentPage = Number(frm._currentPage) > 0 ? Number(frm._currentPage) : 1;
      this.perPage = Number(frm._perPage) > 0 ? Number(frm._perPage) : this.perPage;
      this.sortBy = frm._sortBy || null;
      this.sortDesc = !!frm._sortDesc;
      this.activeStatusBucket = null;
    } else {
      this.form.DistrictID = this.$store.getters.getDistrict;
      this.form.ApplicationStatusID = this.getDefaultStatusForRole(
        this.$store.getters.loggedUser ? this.$store.getters.loggedUser.RoleID : 0,
        this.$store.getters.getAppStatus
      );
      this.form.LoanType = Number(this.$route.params.userLoanType) || this.form.LoanType || 1;
      this.activeStatusBucket = null;
    }

    // Defensive normalization for stale dashboard state that lands on GM only
    // when the route explicitly came from a DGM/GM drilldown.
    if (Number(this.form.ApplicationStatusID || 0) === 16) {
      if (String(this.activeStatusBucket || "").toUpperCase() === "GM") {
        this.form.ApplicationStatusID = 30;
      } else if (String(this.activeStatusBucket || "").toUpperCase() === "DGM") {
        this.form.ApplicationStatusID = 4;
      }
    }

    // Caste filter control is hidden on this screen; keep it empty so
    // old saved values cannot hide valid records.
    this.form.Caste = "";
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.getSchemes();
    this.getApprovalStatus();
    this.castes = this.getDefaultCasteOptions();
    if (this.form.Caste) {
      this.ensureCasteOptionsLoaded(false);
    }
    this.getApplications();

    var userinfo = this.$store.getters.loggedUser;

    if (userinfo.RoleID == 2) {
      this.show = true;
      this.isAdmin = false;
    }
    else if(userinfo.RoleID == 1){
      this.isAdmin = true;
      this.show = false;
    }
    else {
      this.show = false;
      this.isAdmin = false;
    }
  },
  updated() {
    // Final safeguard for async render timing: if visible rows are clearly at
    // DGM recommendation stage, keep status dropdown aligned.
    this.syncStatusDropdownWithVisibleRows();
  }
};
</script>

<style scoped>
.application-queue-page {
  box-sizing: border-box;
  max-width: 100%;
  padding: 0 16px 20px;
  overflow-x: hidden;
}

.application-filter-card {
  border: 1px solid #d8e1ed;
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(30, 58, 95, 0.08);
}

.application-filter-header {
  min-height: 46px;
  padding: 0 14px;
  color: #1f3f72;
  background: #f8fafc;
  border-bottom: 1px solid #dfe7f0;
  font-size: 14px;
  font-weight: 700;
}

.advanced-search-link {
  color: #2563ae;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
}

.advanced-search-link:hover {
  color: #163f78;
  text-decoration: underline;
}

.queue-filter-group {
  margin-bottom: 0;
}

.queue-filter-group /deep/ label {
  margin-bottom: 5px;
  color: #46566e;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.queue-filter-input {
  height: 34px;
  border-color: #becde0;
  border-radius: 5px;
  color: #23334d;
  font-size: 13px;
}

.queue-filter-input:focus {
  border-color: #3b82d0;
  box-shadow: 0 0 0 0.14rem rgba(59, 130, 208, 0.15);
}

.queue-search-button {
  width: 38px;
  border-radius: 0 5px 5px 0;
}

.application-results-table {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.application-results-table /deep/ table {
  min-width: 1080px;
}

@media (max-width: 767px) {
  .application-queue-page {
    padding: 0 8px 16px;
  }

  .queue-filter-group {
    margin-bottom: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Applications.vue